// Strings and locale-bound formatters for the current interface language,
// typed with this product's full dictionary.
import { createUseI18n, type I18n as CoreI18n } from '@quoter/web-core'
import type { Strings } from '@/i18n'

export type I18n = CoreI18n<Strings>
export const useI18n = createUseI18n<Strings>()
